import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';

const SimpleListing = ({
  className,
  listItemClassName,
  list,
  ListItemComponent,
  listItemProps,
}) => {
  const objName = listItemProps && listItemProps.itemObjName;

  return (
    <div className={className || ''}>
      {list.map((item, index) => {
        return (
          <ListItemComponent
            className={listItemClassName || ''}
            key={getIn(item, 'id') || index}
            {...{ [objName]: item, ...listItemProps }}
          />
        );
      })}
    </div>
  );
};

SimpleListing.propTypes = {
  className: PropTypes.string,
  listItemClassName: PropTypes.string,
  list: ImmutablePropTypes.list,
  ListItemComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  listItemProps: PropTypes.object,
};

export default SimpleListing;
